import { render, staticRenderFns } from "./MtsAlacakForm.vue?vue&type=template&id=027fdd16"
import script from "./MtsAlacakForm.vue?vue&type=script&lang=ts"
export * from "./MtsAlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports